import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { Divider } from "@material-ui/core";
import { Typography } from '@material-ui/core'
import { headRewrite } from "../function/headRewrite";
import { Grid } from "@material-ui/core";
import { Helmet } from "react-helmet-async";

const useStyles = makeStyles((theme) => ({
    article:{
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    content:{
        whiteSpace: 'pre-line',
        lineHeight: '25px'
    },
    divider:{
        marginTop:theme.spacing(5),
        marginBottom: theme.spacing(5),
    },
    featureGrid:{
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4),
    },
    guideCard:{
        height: '100%',
        border: '1px solid rgba(23, 23, 23, 0.12)',
        background: '#f7f7f7',
        padding: theme.spacing(3),
        [theme.breakpoints.down('sm')]:{
            padding: theme.spacing(2.5),
        }
    },
    grid:{
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5)
    },
    image:{
        display: 'block',
        width: '100%',
        border: '1px solid rgba(23, 23, 23, 0.12)',
        background: '#f7f7f7',
    },
    intro:{
        maxWidth: 680,
        margin: '0 auto',
        color: 'rgba(23, 23, 23, 0.72)',
    },
    label:{
        display: 'inline-block',
        marginBottom: theme.spacing(1.5),
        fontSize: 11,
        letterSpacing: '0.16em',
        textTransform: 'uppercase',
        color: 'rgba(23, 23, 23, 0.55)',
    },
    note:{
        borderLeft: '3px solid #171717',
        marginTop: theme.spacing(2),
        padding: theme.spacing(1.5, 2),
        background: '#f7f7f7',
        lineHeight: '25px',
    },
    sectionLead:{
        maxWidth: 720,
        margin: '0 auto',
        color: 'rgba(23, 23, 23, 0.72)',
    },
    stepCard:{
        height: '100%',
        borderTop: '1px solid rgba(23, 23, 23, 0.18)',
        paddingTop: theme.spacing(2),
    },
    stepNumber:{
        marginBottom: theme.spacing(1),
        fontSize: 12,
        letterSpacing: '0.18em',
        color: 'rgba(23, 23, 23, 0.45)',
    },
    top_grid:{
        [theme.breakpoints.up('sm')]:{
            display: 'none'
        }
    },
    under_grid:{
        [theme.breakpoints.down('sm')]:{
            display: 'none'
        }
    },
    guide:{
        marginTop:theme.spacing(5),
        marginBottom: theme.spacing(5),
    },
    guide_title:{
        [theme.breakpoints.down('md')]:{
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3)
        },
        [theme.breakpoints.up('md')]:{
            marginTop: '50%'
        }
    },
    root:{
        [theme.breakpoints.down('sm')]:{
            margin: theme.spacing(10,1,15,1)
        },
        [theme.breakpoints.up('sm')]:{
            margin: theme.spacing(10,2,15,2)
        },
        [theme.breakpoints.up('md')]:{
            margin: theme.spacing(10,3,15,3)
        }
    },
    subtitle:{
        marginBottom: theme.spacing(2),
        fontWeight: 'bold'
    },
    title:{
        fontWeight: 'bold',
        marginBottom: theme.spacing(3),
    },
    videoFrame:{
        width: "100%",
        height: 500,
        position: "relative",
        overflow: "hidden",
        background: '#171717',
        border: '1px solid rgba(23, 23, 23, 0.12)',
        [theme.breakpoints.down('sm')]:{
            height: 420,
        }
    },
    video:{
        objectFit: "cover",
        position: "absolute",
        height: "100%",
        width: "100%",
        top: 0,
        left: 0
    }
}))

export default function StartGuideScreen(){
   const classes = useStyles()
   const title = 'Enclopediaの使い方ガイド｜レンタル・購入・返却方法｜Enclopedia【公式サイト】'
   const description = 'Enclopedia（アンクロペディア）の使い方ガイド。アイテム検索、レンタル予約、レンタル後の購入方法、返却袋を使った返送手順を動画とテキストで紹介します。'
   const keyword = 'ファッションレンタル,enclopedia,アンクロペディア,服レンタル,使い方,レンタル方法,購入方法,返却方法,やることリスト'
   const canonicalUrl = `${typeof window !== 'undefined' ? window.location.origin : ''}/help_guide`
   const returnSteps = [
    {
        title: '返却アイテムを袋に入れる',
        body: '購入したアイテムを除き、返却するすべてのアイテムをお届け時に同梱された返却用袋へ入れて封をします。お届け時の梱包材は破棄して問題ありません。',
    },
    {
        title: '返却手続き画面へ進む',
        body: 'やることリスト、または予約履歴一覧から返却手続き画面へ移動し、返却袋の配送番号と画面上の配送番号が一致しているか確認します。',
    },
    {
        title: '返送場所へ持ち込む',
        body: '返却用袋をお近くのセブンイレブン、ファミリーマート、またはヤマト運輸へ持ち込みます。',
    },
    {
        title: '返却ボタンを押す',
        body: '発送後、返却手続き画面で返却ボタンを押すと返送手続きが完了します。',
    },
   ]
   headRewrite(title, description, keyword)
   return(
    <div className={classes.root}>
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keyword} />
            <link rel="canonical" href={canonicalUrl} />
            <meta property="og:type" content="article" />
            <meta property="og:site_name" content="Enclopedia" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonicalUrl} />
            <script type="application/ld+json">
                {JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'FAQPage',
                    mainEntity: [
                        {
                            '@type': 'Question',
                            name: 'Enclopediaでレンタル後に購入できますか？',
                            acceptedAnswer: {
                                '@type': 'Answer',
                                text: '購入はレンタル後に可能です。発送後、レンタル中のみ右上のやることリストに数字が表示され、返却または購入を選べるようになります。',
                            },
                        },
                        {
                            '@type': 'Question',
                            name: '購入価格はどのように計算されますか？',
                            acceptedAnswer: {
                                '@type': 'Answer',
                                text: '表示されている購入価格からレンタル料と返却手数料を差し引いた金額で購入できます。',
                            },
                        },
                        {
                            '@type': 'Question',
                            name: 'レンタルしたアイテムはどのように返却しますか？',
                            acceptedAnswer: {
                                '@type': 'Answer',
                                text: '購入したアイテムを除くすべてのアイテムを返却用袋に入れ、やることリストまたは予約履歴一覧から返却手続きへ進み、配送番号を確認してからコンビニまたはヤマト運輸へ持ち込みます。発送後に返却ボタンを押すと完了です。',
                            },
                        },
                    ],
                })}
            </script>
            <script type="application/ld+json">
                {JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'HowTo',
                    name: 'Enclopediaでレンタルアイテムを返却する方法',
                    description: 'Enclopediaでレンタルしたアイテムを返却用袋で返送する手順です。',
                    step: returnSteps.map((step, index) => ({
                        '@type': 'HowToStep',
                        position: index + 1,
                        name: step.title,
                        text: step.body,
                    })),
                })}
            </script>
        </Helmet>
        <Container maxWidth={"md"} style={{padding: 'initial'}}>
            <Typography variant={"h1"} component="h1" className={classes.title} align="center">
                {"ようこそEnclopedia（アンクロペディア）へ"}
            </Typography>
            <Typography variant="subtitle1" component="p" align="center" style={{fontWeight: 'bold'}} className={classes.content}>
                モードを民主化する。
            </Typography>
            <Typography variant="subtitle1" component="p" align="center" className={`${classes.content} ${classes.intro}`}>
                アイテムの探し方、レンタル予約、レンタル後の購入、返却までの流れをまとめた公式ガイドです。
            </Typography>
                <div style={{textAlign: 'center', marginTop: 15, fontWeight: 'bold'}}>
                    <Button variant="contained" color="primary"  style={{fontWeight: 'bold'}} component={"a"} href="https://www.enclopedia-official.com/" target="_blank" rel="noopener">
                        アイテム一覧を見る
                    </Button>
                </div>
            <Divider classes={{root:classes.divider}}/>
            <Typography variant="h2" component="h2" align="center" className={classes.subtitle}>
                Enclopediaコミュニティ
            </Typography>
            <Typography variant="subtitle1" component="p" align="center" className={classes.content}>
                {"Enclopedia(アンクロペディア)は\
                \nブランドの貴重な過去アーカイブの保存と共有を目的とした、\
                \nファッションレンタルサービスです。\
                \nEnclopediaコミュニティでは過去のコレクションを収集し共有することで、コミュニティに参加していただいたみなさまが気軽にハイファッションを楽しめることを目指しております。\
                \nまたサービスを通して服は買うものではなく借りるものという価値観を一般的にすることで消費を少なくするエシカルファッションにも取り組んでいます。"}
            </Typography>
            <Divider classes={{root:classes.divider}}/>
            <Typography variant="h2" component="h2" align="center" className={classes.subtitle}>
                Enclopedia利用ガイド
            </Typography>
            <Grid container spacing={5} className={classes.guide}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Typography variant="h3" component="h3" align="center" className={classes.guide_title}>
                        アイテムを検索
                    </Typography>
                    <Typography variant="subtitle1" component="p" align="center" style={{whiteSpace:'pre-line'}} >
                        {"Enclopediaで借りたいアイテムを検索しましょう。\
                        \n気に入ったアイテムや次にレンタルしたいアイテムを「お気に入り」に登録、\
                        \n考えたスタイリングをクローゼットに保管して今後のコーデの参考にしたりすることもできます。"}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className={classes.videoFrame}>
                <video loop muted autoPlay playsInline preload="auto" className={classes.video}>
                    <source src="https://media.enclopedia-official.com/media/movie/enclopedia_deploy_guide_1.mp4" type="video/mp4"/>
                </video>
                    </div>
                </Grid>
            </Grid>
            <Grid container spacing={5} className={classes.guide}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.top_grid}>
                <Typography variant="h3" component="h3" align="center" className={classes.guide_title}>
                    アイテムを予約
                </Typography>
                <Typography variant="subtitle1" component="p" align="center" style={{whiteSpace:'pre-line'}} >
                    {"Enclopediaで借りたいアイテムを予約しましょう。\
                    \n気に入ったアイテムをアイテム詳細ページからレンタルリストに追加しましょう。\
                    \nあとはレンタルリストの予約ボタンからお支払いに関する手続きをするだけ。"}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className={classes.videoFrame}>
                <video loop muted autoPlay playsInline preload="metadata" className={classes.video}>
                    <source src="https://media.enclopedia-official.com/media/movie/enclopedia_guide2.mp4" type="video/mp4"/>
                </video>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className={classes.under_grid}>
                    <Typography variant="h3" component="h3" align="center" className={classes.guide_title}>
                        アイテムを予約
                    </Typography>
                    <Typography variant="subtitle1" component="div" align="center" style={{whiteSpace:'pre-line'}} >
                        {"Enclopediaで借りたいアイテムを予約しましょう。\
                        \n気に入ったアイテムをアイテム詳細ページからレンタルリストに追加しましょう。\
                        \nあとはレンタルリストの予約ボタンからお支払いに関する手続きをするだけ。"}
                </Typography>
                </Grid>
            </Grid>
            <Divider classes={{root:classes.divider}}/>
            <Typography variant="h2" component="h2" align="center" className={classes.subtitle}>
                レンタル後に購入する
            </Typography>
            <Typography variant="subtitle1" component="p" align="center" className={`${classes.content} ${classes.sectionLead}`}>
                {"購入はレンタル後に可能です。発送後、レンタル中のみ右上のチェックマーク付きの「やることリスト」に数字が表示され、「返却」「購入」を選べるようになります。"}
            </Typography>
            <Grid container spacing={3} className={classes.featureGrid}>
                <Grid item xs={12} sm={4}>
                    <div className={classes.guideCard}>
                        <span className={classes.label}>Purchase 01</span>
                        <Typography variant="h3" component="h3" className={classes.article}>
                            レンタル中に選択
                        </Typography>
                        <Typography variant="subtitle1" component="p" className={classes.content}>
                            発送後、レンタル中のアイテムのみ購入手続きへ進めます。
                        </Typography>
                    </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <div className={classes.guideCard}>
                        <span className={classes.label}>Purchase 02</span>
                        <Typography variant="h3" component="h3" className={classes.article}>
                            やることリストから進む
                        </Typography>
                        <Typography variant="subtitle1" component="p" className={classes.content}>
                            右上のチェックマーク付き「やることリスト」から「購入」を選びます。
                        </Typography>
                    </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <div className={classes.guideCard}>
                        <span className={classes.label}>Purchase 03</span>
                        <Typography variant="h3" component="h3" className={classes.article}>
                            差し引き後の金額で購入
                        </Typography>
                        <Typography variant="subtitle1" component="p" className={classes.content}>
                            表示されている購入価格からレンタル料・返却手数料を差し引いた金額で購入できます。
                        </Typography>
                    </div>
                </Grid>
            </Grid>
            <Divider classes={{root:classes.divider}}/>
            <Typography variant="h2" component="h2" align="center" className={classes.subtitle}>
                返却方法
            </Typography>
            <Typography variant="subtitle1" component="p" align="center" className={`${classes.content} ${classes.sectionLead}`}>
                レンタルしたアイテムを返却する際は、購入したアイテムを除くすべてのアイテムを返却用袋に入れて返送してください。
            </Typography>
            <Grid container spacing={3} className={classes.featureGrid}>
                <Grid item xs={12} md={6}>
                    <img alt="Enclopediaの返却用袋と返却に必要なもの" src={process.env.REACT_APP_IMAGE_URL + "subscription/enclopedia-help3.webp"} className={classes.image}/>
                    <Typography variant="body2" component="p" className={classes.note}>
                        返却用袋は発送時の梱包材に同梱されています。購入したアイテムは返却不要です。返却袋をなくした場合は任意の梱包を用意してください。
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container spacing={3}>
                        {returnSteps.map((step, index) => (
                            <Grid item xs={12} sm={6} key={step.title}>
                                <div className={classes.stepCard}>
                                    <div className={classes.stepNumber}>STEP {index + 1}</div>
                                    <Typography variant="h3" component="h3" className={classes.article}>
                                        {step.title}
                                    </Typography>
                                    <Typography variant="subtitle1" component="p" className={classes.content}>
                                        {step.body}
                                    </Typography>
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
            <Typography variant="subtitle1" component="p" className={classes.note}>
                {"返却袋をなくした場合は、任意の袋とヤマト運輸の着払い伝票を用意し、返却画面の配送番号を変更してください。"}
            </Typography>
            <Divider classes={{root:classes.divider}}/>
            <Typography variant="h2" component="h2" align="center" className={classes.subtitle}>
                メンバーの信頼性基準
            </Typography>
            <Typography variant="subtitle1" component="p" className={classes.content}>
                {"Enclopediaコミュニティに参加いただいたみなさまには、アイテムを次の方にも気持ちよく使用していただくために、以下のルールをお守りいただくことをお願いしております。\
                \n１、通常使用を超える汚損、損傷が発生しないよう大切に扱う\
                \n２、破損した付属品(ボタンなど)はとっておき返却時に同封する\
                \n３、アイテムに問題（汚れ、破損）が発生した場合運営に連絡する\
                \n４、返却期限日までに返却手続きと発送を完了する\
                \nEnclopediaではメンバーの方が長く清潔な状態でご利用いただけるようアイテムのクオリティの維持に取り組んでいます。"}
            </Typography>
            <Divider classes={{root:classes.divider}}/>
            <Typography variant="h2" component="h2" align="center" className={classes.subtitle}>
                利用開始準備
            </Typography>
            <Typography variant="h3" component="h3" className={classes.article}>
                アカウントの作成
            </Typography>
            <Typography variant="subtitle1" component="p" className={classes.content}>
                {"Enclopediaアカウントの作成は無料で行うことができます。\
                \nいくつかの基本情報を入力することでサービスの利用が開始できます。"}
            </Typography>
            <Typography variant="h3" component="h3" className={classes.article}>
                レンタル前に
            </Typography>
            <Typography variant="subtitle1" component="p" className={classes.content}>
                {"予約前に配送先とお支払い情報（クレジット）を入力していただく必要があります。\
                \nこれでレンタルする準備が整いました。"}
            </Typography>
            <Divider classes={{root:classes.divider}}/>
            <Typography variant="h2" component="h2" align="center" className={classes.subtitle}>
                取扱アイテムに関して
            </Typography>
            <Typography variant="subtitle1" component="p" className={classes.content}>
                {"Enclopedia（アンクロペディア）では現在2次流通の古着を取り扱っております、各アイテムの状態に関しては商品詳細ページにてご覧いただけます。"}
            </Typography>
            <Divider classes={{root:classes.divider}}/>
        </Container>
    </div>
   )
}
